<app-page-header
    title="Configuración de Flujos (BPM)"
    mobileTitle="Flujos BPM"
    icon="fas fa-project-diagram"
    optionsLabel="Opciones"
    optionsIcon="fa fa-cog"
    [hasOptions]="true">
    <div headerOptions>
        <a class="dropdown-item" routerLink="/configuracion/flujos/historial">
            <i class="fas fa-history fa-fw me-2 text-primary"></i> Historial de cambios
        </a>
    </div>
</app-page-header>

<div class="row">
    <div class="col-12"
         [class.col-md-12]="!appSettings.isMobile()"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            <app-status-flow-process-list />
        </div>
    </div>
</div>
